import React, { Component } from 'react';
import { Tabs, Tab, Grid, Row, Col } from 'react-bootstrap';

import { history } from '../../store';
import PageTitle from '../common/page-title/index';
import TeamSubmissionFormPage from './sell-it-uploader/submission-form-page';
import PostcodePlanFormPage from './postcode-plan/postcode-plan-form-page';
import SubmissionsDashboard from './dashboard/submissions-dashboard';
import './index.css';

export const pages = {
  submit_epos_data: 'SUBMIT EPOS/INVOICE',
  my_dashboard: 'MY DASHBOARD'
};

class Submissions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tab: 'submit_ngp_data'
    };
  }

  componentWillMount() {
    const { location: { hash } } = this.props;
    let tab = hash;

    if (!tab) {
      tab = 'submit_ngp_data';
    } else {
      tab = tab.substr(1);
    }

    this.setState({ tab });
    this.handleTabSelect(tab);
  }

  handleTabSelect = (tab) => {
    history.replace(`/submissions#${tab}`);
    this.setState({ tab });
  };

  render() {
    const { tab } = this.state;

    return (
      <Grid bsClass="container" className="sell-it-submissions user-inner-container">
        <Row>
          <Col lg={12} className="sell-it-submissions-title">
            <PageTitle>Submissions</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <Tabs
              activeKey={tab}
              onSelect={this.handleTabSelect}
              id="submissionsTab"
              mountOnEnter
              className="sell-it-submissions-tabs"
            >
              <Tab eventKey="submit_ngp_data" title="BLU&nbsp;BAR&nbsp;SELL&nbsp;IT UPLOADER">
                <TeamSubmissionFormPage isNgp />
              </Tab>
              <Tab eventKey="submit_postcode_plan_data" title="SUBMIT&nbsp;PRICE&nbsp;IT&nbsp;+ EPOS/INVOICE">
                <PostcodePlanFormPage />
              </Tab>
              <Tab eventKey="submit_epos_data" title="SUBMIT&nbsp;SELL&nbsp;IT EPOS/INVOICE">
                <TeamSubmissionFormPage />
              </Tab>
              <Tab eventKey="my_dashboard" title="MY&nbsp;DASHBOARD">
                <SubmissionsDashboard
                  handleTabSelect={this.handleTabSelect}
                />
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default Submissions;



// WEBPACK FOOTER //
// ./src/components/submissions/index.jsx